"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ImagePlaceholder() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="imageplaceholder" className="w-full bg-background overflow-hidden !p-0">
      <div ref={ref} className={cn("w-full transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="relative w-full overflow-hidden shadow-2xl bg-muted">
          <AspectRatio ratio={21 / 9} className="bg-cover bg-no-repeat !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/04/lyon_skyline_dusk_desaturated.jpg)]">
            
            {}
            <div className="absolute inset-0 bg-black/10 pointer-events-none" />
          </AspectRatio>
        </div>
      </div>
    </section>;
}